export default "__VITE_ASSET__CcE3pP8w__"